var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0V0C31.0457 0 40 8.95431 40 20V20C40 31.0457 31.0457 40 20 40V40C8.95431 40 0 31.0457 0 20V20Z",
    fill: "#1882FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7819 23.9184V26.0727C26.7827 26.2727 26.7417 26.4707 26.6616 26.6539C26.5815 26.8372 26.464 27.0017 26.3166 27.1369C26.1692 27.2721 25.9952 27.375 25.8058 27.4391C25.6163 27.5031 25.4156 27.5269 25.2164 27.5089C23.0067 27.2688 20.884 26.5137 19.0191 25.3043C17.284 24.2018 15.813 22.7307 14.7104 20.9957C13.4968 19.1223 12.7415 16.9893 12.5058 14.7696C12.4879 14.5711 12.5115 14.3709 12.5751 14.182C12.6388 13.993 12.7411 13.8194 12.8755 13.6721C13.0099 13.5248 13.1735 13.4072 13.3559 13.3266C13.5383 13.2461 13.7355 13.2044 13.9349 13.2042H16.0892C16.4376 13.201 16.7752 13.3245 17.0393 13.5517C17.3035 13.7787 17.5247 14.4393 17.5247 14.4393L18.0274 16.4572C18.0274 16.4572 18.1452 16.9936 18.0877 17.2615C18.0305 17.5303 17.8974 17.777 17.7042 17.9724L16.793 18.8844C17.8152 20.6822 19.3038 22.1708 21.1016 23.1931L22.0136 22.2811C22.209 22.0879 22.4558 21.9548 22.7246 21.8976C22.9924 21.8402 23.5288 21.9579 23.5288 21.9579L25.5467 22.4606C25.5467 22.4606 26.2146 22.6854 26.4422 22.9547C26.6697 23.2234 26.7906 23.5664 26.7819 23.9184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contact_phone.570617cf24623e866ce0e67e9e9b12fb.svg";
export { ForwardRef as ReactComponent };